import * as React from "react";
import { Tabs } from "antd";
import { CardBox } from "../atoms";
import { HeatMapOutlined } from "@ant-design/icons";
import MapSummary from "../charts/map";

const { TabPane } = Tabs;

const Geo = () => {
  return (
    <div className="rounded relative ">
      <div className="my-3">
        {" "}
        The collected dataset contains 8.6 million geotagged tweets. We can
        visualize these locations (weighted by frequency) to understand clusters
        and sources of discourse.
      </div>
      <div className="bg-white   flex-1 rounded  bg-gpray-100 ">
        <Tabs defaultActiveKey="1">
          <TabPane
            tab={
              <span>
                <HeatMapOutlined />
                Geo tagged Tweets
              </span>
            }
            key="1"
          >
            <div className="flex md:flex-row gap-2 flex-col ">
              <div className="bg-gray-50 p-3 rounded">
                <div className="flex gap-2">
                  <div className="gap-2 flex  md:flex-col">
                    <CardBox
                      title="Geo tagged Tweets"
                      description="Geo tagged tweets"
                      value="8.6M"
                    />
                    <CardBox
                      title="Geo tagged Tweets"
                      description="Geo tagged to Nigeria"
                      value="8.0M"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-1">
                {" "}
                <MapSummary />
              </div>
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default Geo;
